import type { QuestionModule } from "../contracts";
import {
  videoCore,
  type VideoRaw,
  type VideoDefinition,
  type VideoDraft,
  type VideoEvent,
  type VideoResponse,
} from "./core";
import { VideoView } from "./views";

export const videoModule: QuestionModule<
  VideoRaw,
  VideoDefinition,
  VideoDraft,
  VideoEvent,
  VideoResponse
> = {
  type: "video",
  galleryFeatures: [
    "baseline",
    "playback",
    "dial-bottom",
    "dial-right",
    "samples",
    "timed",
  ],
  core: videoCore,
  prompt: () => ({ content: "" }),
  views: {
    default: {
      id: "default",
      label: "Video",
      component: VideoView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
      space: "expanded",
    },
  },
  defaultDisplay: { view: "default" },
  controls: (_definition, draft, _display, copy) => ({
    ...(draft.ended
      ? {
          primaryAction: {
            purpose: "submit" as const,
            label: copy.actions.continue,
            disabled: !draft.completionReady,
            pending: !draft.completionReady && !draft.completionFailed,
            action: { type: "submit" as const },
          },
        }
      : {}),
  }),
};
